/**
 * Custom select with block indicating custom CSS class
 */
$('.field.dropdown select').customSelect({
    block: 'select-custom-element'
});

/**
 * On change of select, submit closest form
 */
$('.field.dropdown.js-dropdown-form-submit select').change(function() {
    var $form = $(this).closest('form');
    $form.submit();
});
